export default "./dist/stdassets/images/icons/view-refresh.png";